import {BridgeComponent} from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "nfc-contact"
  static targets = [
    "button",
    "firstName", "lastName", "organization", "jobTitle",
    "email", "phone",
    "streetAddress", "city", "state", "postalCode", "country",
    "url"
  ]

  connect() {
    super.connect()
    this.send("connect", {}, ({nfcSupported}) => {
      if (nfcSupported) {
        this.buttonTarget.classList.remove("hidden")
      }
    })
  }

  scan() {
    this.send("scan", {}, (response) => {
      if (response.error) {
        // Handle error — e.g., show a flash message or alert
        console.warn("NFC scan error:", response.error)
        return
      }

      // Pre-fill form fields
      const fields = [
        "firstName", "lastName", "organization", "jobTitle",
        "email", "phone",
        "streetAddress", "city", "state", "postalCode", "country",
        "url"
      ]
      fields.forEach(field => {
        if (this[`has${capitalize(field)}Target`] && response[field]) {
          this[`${field}Target`].value = response[field]
        }
      })
    })
  }
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
